export default {
    label_task:{
        en:"Areas",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New Area",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit Area",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details of Area",
        bn:'ব্যবহারকারীর বিবরণ'
    },
}